module.exports = __webpack_public_path__ + "static/img/21.85ccbce4.jpg";